// Keeps only the columns currently displayed in the grid (used by gridOptions.excelVisibleColumnsOnly).
export const filterToDisplayedColumns = (leafColumns, displayedColIds) => {
  const displayed = new Set(displayedColIds);
  return leafColumns.filter((col) => displayed.has(col.colId || col.field));
};

export default filterToDisplayedColumns;
